export default __webpack_public_path__ + "static/media/carta-porte_formas.b5c0e099.png";